import { tickerItems } from "@/mocks/site";

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <div className="flex items-center border-y border-background-200 bg-background-100">
      <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 text-xs font-medium text-background-50 md:px-6">
        <i className="ri-flashlight-fill"></i>
        <span className="whitespace-nowrap">实时滚动</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="marquee-track flex w-max items-center gap-10 py-3 pl-6">
          {loop.map((item, idx) => (
            <span
              key={`${item}-${idx}`}
              className="flex items-center gap-3 whitespace-nowrap text-sm text-foreground-700"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}